export default __webpack_public_path__ + "static/media/xapiwrapper.js.f563450a.ld";